const formatDuracion = (value) => {
  const modalidades = {
    "1_ano": "1 año",
    "3_anos": "3 años",
 
    "4_anos": "4 años",
    "4_anos_y_medio": "4 años y medio",
    "6_meses": "6 meses",
    "6_anos": "6 años",
  };

  if (modalidades[value]) return modalidades[value];

  // fallback automático
  return value?.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
};

const Duracion = ({ value }) => {
  if (!value) return null;

  return <>{formatDuracion(value)}</>;
};

export default Duracion;
